import React, {useEffect, useRef, useState} from 'react';
import {FaArrowUp, FaQuestion} from "react-icons/fa";
import Button from "../../../../components/button/button.jsx";
import {getAssetPath} from "../../../../utils/get-asset-path.js";
import ReverseArrowClock from "../../../../components/icons/reverse-arrow-clock.jsx";

const SmartSearchArea = ({value = "", onChange, onSearch, onShowLastRecords, disabled, isSearching}) => {
    const [showHelp, setShowHelp] = useState(false);
    const helpRef = useRef(null);

    useEffect(() => {
        if (!showHelp) return;

        const handleClickOutside = (event) => {
            if (helpRef.current && !helpRef.current.contains(event.target)) {
                setShowHelp(false);
            }
        };

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setShowHelp(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [showHelp]);

    return (
        <div className={`h-[calc(100vh-267px)] relative flex items-center justify-center overflow-hidden rounded-sm bg-[#F8FAFC] text-center`}>
            <img
                src={getAssetPath("img/bos-list/ellipse.svg")}
                alt=""
                className="pointer-events-none absolute left-1/2 top-1/2 z-0 w-190 max-w-[80%] -translate-x-1/2 -translate-y-1/2"
                aria-hidden="true"
            />
            <div className="relative z-10 flex w-full flex-col items-center ">
                <div className="mb-[24px] flex items-center gap-4 text-[#063A6C] ">
                    <img
                        src={getAssetPath("img/bos-list/icon-search.svg")}
                        alt=""
                        className="w-7.5"
                        aria-hidden="true"
                    />
                    <h2 className="text-[32px]! font-bold leading-none">Pesquisa inteligente</h2>
                </div>
                <p className="mb-[40px] text-[20px] font-bold text-[#4B5563]">O que você deseja pesquisar?</p>
                <div className="relative mb-[12px] w-full max-w-140">
                    <input
                        id="smartSearch"
                        type="text"
                        value={value}
                        disabled={disabled || isSearching}
                        onChange={({target}) => onChange(target.value)}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                event.preventDefault();
                                event.stopPropagation();
                                onSearch();
                            }
                        }}
                        placeholder="Liste os BOs de perturbação de sossego dos últimos 6 meses"
                        className="h-12 w-full rounded-md border border-[#8C8C8C] bg-white px-4 pr-24 text-[16px] text-[#374151] shadow-md outline-none placeholder:text-[#B9B9B9] focus:border-[#063A6C] disabled:bg-[#e9ecef] disabled:cursor-not-allowed"
                    />
                    <div ref={helpRef}>
                        <button
                            type="button"
                            className="absolute right-12 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-md bg-[#E5E7EB] text-[#063A6C] focus:outline-none focus:ring-1 focus:ring-blue-300"
                            title="Ajuda"
                            aria-label="Ajuda"
                            aria-expanded={showHelp}
                            onClick={() => setShowHelp((prev) => !prev)}
                        >
                            <FaQuestion/>
                        </button>

                        {showHelp && (
                            <div className="absolute bottom-full right-0 z-20 mb-2 w-92 rounded-md border border-[#D1D5DB] bg-white p-3 text-left text-[13px] leading-5 text-[#374151] shadow-lg">
                                <p className="mb-1 inline-flex rounded-sm bg-[#E8F1FA] px-2 py-1 font-bold text-[#063A6C]">
                                    Exemplos de uso:
                                </p>
                                <ul className="space-y-1">
                                    <li className="flex gap-2">
                                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#063A6C]"/>
                                        <span>Ocorrências de furto de veículos em abril de 2026</span>
                                    </li>
                                    <li className="flex gap-2">
                                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#063A6C]"/>
                                        <span>BOs no bairro Santo Antônio entre abril e junho de 2025</span>
                                    </li>
                                    <li className="flex gap-2">
                                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#063A6C]"/>
                                        <span>Furto de carga em 04 de abril de 2024</span>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                    <button
                        type="button"
                        className="cursor-pointer absolute right-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-md bg-[#063A6C] text-white hover:bg-blue-800 focus:outline-none focus:ring-1 focus:ring-blue-300 disabled:cursor-not-allowed disabled:opacity-70 disabled:bg-[#9B9B9B]"
                        title="Pesquisar com IA"
                        disabled={disabled || isSearching || !value.trim()}
                        onClick={onSearch}
                    >
                        <FaArrowUp/>
                    </button>
                </div>
                <div className="flex w-full max-w-140 justify-end">
                    <button type="button" className="flex items-center gap-2 text-[#063A6C] hover:cursor-pointer"
                            onClick={onShowLastRecords}
                    >
                        <ReverseArrowClock/>
                        <span className="font-bold text-[16px]">Ver últimos registros</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SmartSearchArea;
